<template>
  <div class="row">
   

    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('member.form.competency.title') }}</span> <a name="action">&nbsp;</a> 
        </div>
        <div class="card-body">

          <div class="row">
            <div class="form-group col-md-3"> 
              <select v-model="levelone" class="form-control" id="level1"  :placeholder="$t('member.form.competency.level1')" >>
                <option v-for="s in competencyTree.items" :value="s" :key="s.id">{{s.name}}</option>
              </select>
            </div>
            <div class="form-group col-md-4"> 
              <div v-if="levelone != null && levelone.childCompetencys != null && levelone.childCompetencys.length != 0">
                <select v-model="leveltwo" class="form-control" id="level2" :placeholder="$t('member.form.competency.level2')" >
                  <option v-for="s in levelone.childCompetencys" :value="s" :key="s.id">{{s.name}}</option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-4">
              <div v-if="leveltwo != null && leveltwo.childCompetencys != null && leveltwo.childCompetencys.length != 0">
                <select v-model="levelthree" class="form-control" id="level3" :placeholder="$t('member.form.competency.level3')" >>
                  <option v-for="s in leveltwo.childCompetencys" :value="s" :key="s.id">{{s.name}}</option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-1">
              <div class="float-right"  v-if="compMode != CRUDMODE.READ">
                <a href="#action" @click="addCompetency"><span class="fa fa-plus fa-lg"></span></a>
              </div>
            </div>
          </div>
          
          <div class="row">
            <table id="dataTableAction" width="100%" cellspacing="0" class="table table-bordered table-striped dataTable" >
             <thead>
                <tr>
                  <th>{{ $t('member.form.competency.name') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>{{ $t('member.form.competency.name') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </tfoot>
              <tbody v-if="competencys">
                <tr class="odd" v-if="competencys.length == 0">
                    <td valign="top" colspan="5" class="dataTables_empty">Aucune donnée disponible dans le tableau</td>
                </tr>
                <tr v-for="(item, index) in competencys" v-bind:data-id="item.id" :key="item.id">
                  <td>
                    {{ findTree(item.competency) }}
                  </td>
                  <td align="center" v-if="compMode != CRUDMODE.READ">
                    <a  class="text-danger" v-bind:title="$t('form.delete_button')" href="#entrepreneur" v-on:click="removeCompetency(index)">
                        <span class="fa fa-lg fa-trash"></span>
                    </a>
                  </td> 
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
 
  </div>
</template>

<script>
  import {CompetencyServiceClient, CompetencyDto, MemberCompetencyDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'

  export default {
    name: 'CreateMemberCompetency',
    inject: ['$validator'],
    props: {
      competencys: {},
    },
    data() {
      return {
        competencyTree: [],
        levelone: null,
        leveltwo: null,
        levelthree: null,
      }
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      findTree: function(item, list) {
        if (list == null) list = this.competencyTree.items

        for (let i = 0; i < list.length; i++) {
          if (list[i].id === item.id) {
            return list[i].name
          }

          if (list[i].childCompetencys && list[i].childCompetencys.length != 0) {
            let find = this.findTree(item, list[i].childCompetencys)
            if (find !== undefined) {
              return list[i].name + ' >> ' + find
            }
          }
        }
      },
      fetchData: function() {
        let competencyServiceClient = ServiceFactory.create(CompetencyServiceClient)
        let getCompetencys = competencyServiceClient.getAll(undefined, false, '', 0, 1000)
        let self = this
        getCompetencys
          .then(res => {
            self.competencyTree = res
          })
          .catch(err => {
            err
          })
      },
      addCompetency: function() {
        if (this.leveltwo != null) {
          let competency = null

          if (this.leveltwo.childCompetencys && this.leveltwo.childCompetencys.length != 0 && this.levelthree != null) {
            competency = this.levelthree
          } else if (
            this.leveltwo.childCompetencys == null ||
            (this.leveltwo.childCompetencys != null && this.leveltwo.childCompetencys.length == 0)
          ) {
            competency = this.leveltwo
          }

          if (
            competency != null &&
            !_.find(this.competencys, x => {
              return x.competency.id == competency.id
            })
          ) {
            this.levelone = null
            this.leveltwo = null
            this.levelthree = null

            competency.parentCompetency = null
            competency.childCompetencys = null
  
            let dto = new MemberCompetencyDto()
            dto.init({})
            dto.competency = competency
            dto.competencyId = competency.id
            this.competencys.push(dto)
          }
        }
      },
      removeCompetency: function(index) {
        this.competencys.splice(index, 1)
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/members/CreateMemberCompetency.vue